import axios from 'axios'
import router from '@/router'
import { Message } from 'element-ui'
// 请求拦截
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers['X-Token'] = token
    }
    return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error

    if (response) {
      if (response.status === 401) {
        localStorage.removeItem('token')
        router.replace({ name: 'home' })
        // ⛔ 中断 Promise 链，不再进入 then / catch
        return new Promise(() => {})
      }

      // ⭐ 非 200 的情况：如果有 message，就提示
      const msg =
      typeof response.data === 'string'
        ? response.data
        : response.data?.message
        console.log(response, msg);
      if (msg) {
        // element-plus / element-ui
        // eslint-disable-next-line no-undef
        Message.error(msg)
        // 或 this.$message.error(msg)（如果你在 Vue 实例里）
      }

      return Promise.reject(error)
    }

    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject(error)
  }
)

export default axios
